import { Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { BillComponent } from './bill/bill.component';

export const routes: Routes = [
  { path: 'bill/:billNumber', component: BillComponent },

];
